import { UIText1 } from '@cian/ui-kit';
import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { INFRASTRUCTURE_MAP_ICON_MAP } from '../../constants/infrastructureIcons';
import { EType } from '../../types/map';
import { VerticalScrollable } from '../VerticalScrollable';

export interface IInfrastructureMapTypes {
  types: { title: string; type: EType }[];
  currentTypes: string[];
  isFullscreen?: boolean;
  setType(type: string): void;
}

export function InfrastructureMapTypes({ types, currentTypes, isFullscreen, setType }: IInfrastructureMapTypes) {
  const handleClick = (type: string) => () => {
    setType(type);
  };

  return (
    <div className={classNames(styles['list'], isFullscreen && styles['list--fullscreen'])}>
      <VerticalScrollable horizontalAlign>
        {types.map(({ title, type }) => {
          const checked = currentTypes.includes(type);
          const Icon: React.FunctionComponent<{ color?: string }> | undefined = INFRASTRUCTURE_MAP_ICON_MAP.get(type);

          if (!Icon) {
            return null;
          }

          return (
            <React.Fragment key={title}>
              <input
                type="radio"
                name={'infrastructureMapTypes'}
                defaultChecked={checked}
                className={styles['input']}
                id={`infrastructure-map_${type}`}
              />
              <label
                aria-label={title}
                htmlFor={`infrastructure-map_${type}`}
                className={styles['label']}
                onClick={handleClick(type)}
              >
                {Icon && (
                  <span className={styles['icon']}>
                    <Icon color={'gray_icons_100'} />
                  </span>
                )}
                <UIText1>{title}</UIText1>
              </label>
            </React.Fragment>
          );
        })}
      </VerticalScrollable>
    </div>
  );
}
